<template>
    <div class="flex uppercase text-2xs text-center">
        <div class="w-full" v-for="(weekday, index) in weekdays" :key="index">
            <div v-if="weekday === getDayNameInLocale(deliveryDayName)" class="leading-snug">
                {{ $t('CALENDAR_HEADER_DELIVERY_DAY') }}
                <img class="mx-auto h-1 mb-2" src="@/assets/images/decoration/arrow-down-black.png">
            </div>

            <div v-else-if="weekday === getDayNameInLocale(cutOffDayName)" class="leading-snug">
                {{ $t('CALENDAR_HEADER_NO_MORE') }}
                <img class="mx-auto h-1 mb-2" src="@/assets/images/decoration/arrow-down-black.png">
            </div>
        </div>
    </div>
</template>

<script>
import * as moment from 'moment';
import langPool from '@/content/language';

export default {
    name: 'CalendarHeader',
    computed: {
        localeSelected() {
            return this.$root.$i18n.locale.split('-')[1];
        },
        cutOffDayName() {
            return this.$store.getters['scheduledOrder/getCutOffDayName'];
        },
        deliveryDayName() {
            return this.$store.getters['scheduledOrder/getDeliveryDayName'];
        },
        weekdays() {
            this.$moment.locale(process.env.VUE_APP_MOMENT_LOCALE, {
                week: {
                    dow: 1,
                },
            });
            return this.$moment.weekdays(true);
        },
    },
    methods: {
        getDayNameInLocale(day) {
            const localeDays = langPool[this.localeSelected];
            return localeDays[day];
        },
    },
};
</script>
